import React, { Component, type ErrorInfo } from 'react'

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
  errorMessage: string | null
}

class ErrorBoundary extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      errorMessage: null,
      hasError: false
    }
  }

  static getDerivedStateFromError (error: Error): State {
    console.log(error)
    return { errorMessage: error?.message, hasError: true }
  }

  componentDidCatch (error: Error, errorInfo: ErrorInfo): void {
    console.error(error, errorInfo)
  }

  render (): React.ReactNode {
    if (this.state.hasError) {
      return (

        <div
          className="box-border text-base bg-red-100 px-4 py-3 rounded-lg shadow-lg"
        >
          <h1 className="text-red-700 pb-2">An Error has occurred.  Refresh the page or try again later.</h1>
          <p className="text-sm text-red-700">Error: {this.state.errorMessage}</p>
          <div
            className="absolute w-8 h-6 left-1/2 transform -translate-x-1/2 translate-y-1 z-40 text-red-100 text-xl"
          >▼
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
